import gql from 'graphql-tag'

export const ROLES = gql`
    query AllUserRolesQuery {
        roles: userRoles {
            id,
            code
        }
    }`